import Grid from "@mui/material/Grid";
import ButtonBase from "@mui/material/ButtonBase";
import { IContractProps } from "../../models";
import { MainDetailsHeading } from "./MainDetailsHeadding";
import { Img } from "../../../../components/common";
import styles from "./styles.module.css";
import { Box } from "@mui/system";

export const MainDetails = ({ contract }: IContractProps) => {
  return (
    <Grid container direction="row" alignItems="center">
      <Grid container spacing={2}>
        {contract?.itemDetail?.images.length > 0 && (
          <Grid item width="274px">
            <ButtonBase>
              <Box
                alt="complex"
                component="img"
                className={styles.itemDetailImage}
                src={contract?.itemDetail?.images?.pop()}
              />
            </ButtonBase>
          </Grid>
        )}
        <MainDetailsHeading contract={contract} />
      </Grid>
    </Grid>
  );
};
